"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.4.1'] && _();
}
catch (e) { }
